import { render, staticRenderFns } from "./reloadResident.vue?vue&type=template&id=040d9d60&"
import script from "./reloadResident.vue?vue&type=script&lang=js&"
export * from "./reloadResident.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports